import { Injectable } from '@angular/core';
import moment from 'moment';

type ExportDefinition = {
    data?: {
        category_ref?: string;
    };
};

@Injectable({
    providedIn: 'root',
})
export class StatisticsExportBuilderService {
    buildCategoryRef (
        startDate: moment.Moment | string | undefined,
        endDate: moment.Moment | string | undefined,
        dateFormat: string,
        ...extraSegments: Array<string | number | undefined>
    ): string {
        const start = this.toDateString(startDate, dateFormat);
        const end = this.toDateString(endDate, dateFormat);
        const segments = [
            start,
            end,
            ...extraSegments.filter((segment): segment is string | number => segment !== undefined && segment !== ''),
        ];

        return segments.join(',');
    }

    applyCategoryRef (
        exports: ExportDefinition[],
        startDate: moment.Moment | string | undefined,
        endDate: moment.Moment | string | undefined,
        dateFormat: string,
    ): void {
        const categoryRef = this.buildCategoryRef(startDate, endDate, dateFormat);

        exports.forEach((item) => {
            if (!item.data) {
                item.data = {};
            }

            item.data.category_ref = categoryRef;
        });
    }

    private toDateString (date: moment.Moment | string | undefined, dateFormat: string): string {
        if (!date) {
            return '';
        }

        if (typeof date === 'string') {
            return date;
        }

        return date.format(dateFormat);
    }
}
